import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import sponsors from './Sponsors';

class Map extends Component {
  constructor(props){
    super(props);
    this.state = {
      currentPosition: {
        lat: 45.507845, lng: -73.571653
      },
	  zoom: 14
    };
  }

  apiIsLoaded(map, maps){
    navigator?.geolocation.getCurrentPosition(
        ({coords: {latitude: lat, longitude: lng}}) => {
            const pos = {lat, lng};
            this.setState({currentPosition: pos});
            let infowindow = new maps.InfoWindow({
                content: '<div style="font-size: 16px;">You are here</div>'
            })
            let marker = new maps.Marker({
                position: pos,
                map: map,
                title: "User"
            })
            marker.addListener("click", () => {
                infowindow.open({
                    anchor: marker, 
                    map,
                    shouldFocus: false,
                })
            })
            infowindow.open(map, marker);
        }, (err) => {
            console.warn(`ERROR(${err.code}): ${err.message}`);
        }
    );
    for(var i = 0; i < sponsors.length; i++){
        let infowindow = new maps.InfoWindow({
            content: '<div><div style="font-size: 16px;">' + sponsors[i].title + '</div><div style="font-size: 14px; color: grey;">' + sponsors[i].discount + "</div></div>"
        })
        let marker = new maps.Marker({
            position: sponsors[i].position,
            map: map, 
            title: sponsors[i].title
        })
        marker.addListener("click", () => {
            infowindow.open({
                anchor: marker,
                map, 
                shouldFocus: false,
            })
        })
    }
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: 'calc(150px + 45vh)', width: '80%', marginLeft: "auto", marginRight: "auto" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyDo63VHfTd2_kcOL5PDpS50OpoNJ4BFWy0" }}
          defaultCenter={{lat: 45.507845, lng: -73.571653}}
          defaultZoom={this.state.zoom}
          center={this.state.currentPosition}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded = {({ map, maps }) => this.apiIsLoaded(map, maps)}
        >
        </GoogleMapReact>
      </div>
    );
  }
}

export default Map;